import React from 'react';
import { string, arrayOf, shape, func, object, number } from 'prop-types';
import styles from './styles/styles.module.scss';
import { MOBILE_LANDSCAPE_BREAKPOINT } from '../../../../utils/constants/breakpoints';
import FeedToggleDropdown from '../FeedToggleDropdown';
import CommunityConnect from '../../../../components/svg/shared/CommunityConnect';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    COMMUNITY: { COMMUNITY }
  }
} = StringConstantsMixin;

const FeedHeader = ({ activeFeedKey, feedOptions, handleActiveFeedChange, windowWidth, dispatchCommunityModal }) => {
  return (
    <div className={styles.titleAndFilter}>
      <h2 className={styles.header}>{COMMUNITY}</h2>
      {activeFeedKey && feedOptions && (
        <FeedToggleDropdown
          activeFeedKey={activeFeedKey}
          feedOptions={feedOptions}
          handleLinkClick={handleActiveFeedChange}
          alignment={windowWidth && windowWidth >= MOBILE_LANDSCAPE_BREAKPOINT ? 'bottom-left' : 'bottom-right'}
        />
      )}
      <button type="button" className={styles.communityTrigger} onClick={dispatchCommunityModal}>
        <CommunityConnect />
      </button>
    </div>
  );
};

FeedHeader.propTypes = {
  activeFeedKey: string,
  feedOptions: arrayOf(shape({ label: string, links: object, name: string })),
  handleActiveFeedChange: func,
  windowWidth: number,
  dispatchCommunityModal: func
};

FeedHeader.defaultProps = {
  activeFeedKey: null,
  feedOptions: null,
  handleActiveFeedChange: () => {},
  windowWidth: null,
  dispatchCommunityModal: () => {}
};

export default FeedHeader;
